import React, { Component } from 'react';

import './InfoCell.css';
import ExternalLink from './ExternalLink';

class InfoCell extends Component {
  render() {

    const {
      item,
      shadowItem,
    } = this.props;

    let tags = null;
    let link = null;
    let separator = null;
    let user = null;
    if (item.tags) {
      tags = (
        <div className="lp-tags">
          <div className="lp-shadow">
            {shadowItem.tags}
          </div>
          <div className="lp-overlay">
            {item.tags}
          </div>
        </div>
      );
    }
    if (item.link) {
      link = (
        <div className="lp-link">
          <ExternalLink data={item.link} />
        </div>
      );
    }
    if (item.user) {
      separator = (
        <div className="lp-separator" />
      );
      user = (
        <div className="lp-user">
          {item.user}
        </div>
      );
    }

    return (
      <div className="lp-info-cell">
        {tags}
        <div className="lp-title">
          <div className="lp-shadow">
            {shadowItem.title}
          </div>
          <div className="lp-overlay">
            {item.title}
          </div>
        </div>
        <div className="lp-content">
          <div className="lp-shadow">
            {shadowItem.content}
          </div>
          <div className="lp-overlay">
            {item.content}
          </div>
        </div>
        {link}
        {separator}
        {user}
      </div>
    );
  }
}

export default InfoCell;



// WEBPACK FOOTER //
// ./src/components/InfoCell.js